import config from '@/config'

export default {
	id: 'SIMPLE_UPGRADE_3M_47_2',
	providers: {
		stripe: config('stripe_cheap_and_short_upgrade_3_month'),
		braintree: 'pro_short_cheap_upgrade',
		paltaMap: {
			USD: 'simple_premium_3m_47_2_usd',
			EUR: 'simple_premium_3m_47_2_eur',
			GBP: 'simple_premium_3m_47_2_gbp',
			AUD: 'simple_premium_3m_71_aud',
			CAD: 'simple_premium_3m_71_2_cad',
			DKK: 'simple_premium_3m_351_2_dkk',
			SEK: 'simple_premium_3m_559_2_sek',
			NOK: 'simple_premium_3m_559_2_nok',
			BRL: 'simple_premium_3m_143_20_brl',
			MXN: 'simple_premium_3m_783_2_mxn',
			TRY: 'simple_premium_3m_1519_try',
			ARS: 'simple_premium_3m_62990_ars',
			COP: 'simple_premium_3m_191590_cop',
			CLP: 'simple_premium_3m_45820_clp',
		},
		primer: 'prd_oDQYprrLupKd',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 47.2,
			EUR: 47.2,
			GBP: 47.2,
			AUD: 71.2,
			CAD: 71.2,
			DKK: 351.2,
			SEK: 559.2,
			NOK: 559.2,
			BRL: 143.2,
			MXN: 783.2,
			TRY: 1519,
			ARS: 62990,
			COP: 191590,
			CLP: 45820,
		},
	},
}
